<mat-drawer-container class="main-container">
  <mat-drawer #drawer class="sidenav" [mode]="drawerMode" opened="true">
    <app-menu-operator></app-menu-operator>
  </mat-drawer>
  <app-toolbar-operator [drawer]="drawer"></app-toolbar-operator>
  <div class="app-home">
    <router-outlet></router-outlet>
  </div>
</mat-drawer-container>
